export function aggregateOrders(rawOrders: Record<string, uui.domain.client.rm.ExtendedOrder>) {
  return Object.values(rawOrders).reduce<Record<string, uui.domain.client.rm.Order>>(
    (acc, extOrder) => {
      acc[extOrder.order.id] = extOrder.order
      return acc
    },
    {},
  )
}
